/* import __COLOCATED_TEMPLATE__ from './appointments-feature-upsell.hbs'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { equal, readOnly } from '@ember/object/computed';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { UPSELL_TYPE } from '@square/appointments-feature-upsell/constants';
import { upsellTrackingData, UPSELL_EVENT_DELAY } from '@square/appointments-feature-upsell/utils/events';
var POPOVER_HORIZONTAL_POSITION = /*#__PURE__*/function (POPOVER_HORIZONTAL_POSITION) {
  POPOVER_HORIZONTAL_POSITION["START"] = "start";
  POPOVER_HORIZONTAL_POSITION["END"] = "end";
  return POPOVER_HORIZONTAL_POSITION;
}(POPOVER_HORIZONTAL_POSITION || {});
var POPOVER_VERTICAL_POSITION = /*#__PURE__*/function (POPOVER_VERTICAL_POSITION) {
  POPOVER_VERTICAL_POSITION["TOP"] = "top";
  POPOVER_VERTICAL_POSITION["BOTTOM"] = "bottom";
  return POPOVER_VERTICAL_POSITION;
}(POPOVER_VERTICAL_POSITION || {});
let AppointmentsFeatureUpsellComponent = (_dec = readOnly('planDetailForFeature.name'), _dec2 = readOnly('appointmentsSubscription.dataLoaded'), _dec3 = equal('planDetailForFeature.freeTrialDaysLeft', 0), _class = class AppointmentsFeatureUpsellComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor, this);
    _initializerDefineProperty(this, "appointmentsFeatureInfo", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "router", _descriptor5, this);
    // event tracking
    _defineProperty(this, "hoverTimeout", null);
    _initializerDefineProperty(this, "planName", _descriptor6, this);
    _initializerDefineProperty(this, "planGroupFetched", _descriptor7, this);
    _initializerDefineProperty(this, "hasUsedFreeTrial", _descriptor8, this);
  }
  get planDetailForFeature() {
    return this.appointmentsSubscription.getPlanDetailsOfFeature(this.args.featureId);
  }
  get upsellType() {
    return this.args.upsellType ?? UPSELL_TYPE.PAYWALL;
  }
  get popoverVerticalPosition() {
    return this.args.popoverVerticalPosition ?? POPOVER_VERTICAL_POSITION.BOTTOM;
  }
  get popoverHorizontalPosition() {
    return this.args.popoverHorizontalPosition ?? POPOVER_HORIZONTAL_POSITION.END;
  }

  // Although canManageSubscriptions is not an optional argument, we still check
  // with optional chaining in case it is not provided in the Handlebars template.
  get canManageSubscriptions() {
    return this.args.canManageSubscriptions ?? false;
  }
  get skipPopover() {
    return this.args.skipPopover ?? false;
  }
  get popoverPlacement() {
    return [this.popoverVerticalPosition, this.popoverHorizontalPosition].join('-');
  }
  get pillText() {
    return this.appointmentsSubscription.isOnFreeSubscription ? this.intl.t('apptsUpsell.common.upgrade') : this.planName;
  }
  get popoverSkidding() {
    return this.popoverHorizontalPosition === POPOVER_HORIZONTAL_POSITION.END ? '16' : '-16';
  }
  clickIconOrPopover(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.skipPopover && this.args.openFeatureDetailsModal) {
      this.args.openFeatureDetailsModal();
    }
  }
  trackFeatureUpsellViewed() {
    this.dataApi.track('View Subscription Entry Point', upsellTrackingData({
      routerService: this.router,
      planToken: this.appointmentsFeatureInfo.getPlanTokenOfFeature(this.args.featureId),
      featureId: this.args.featureId,
      upsellType: this.upsellType,
      hasUsedFreeTrial: this.hasUsedFreeTrial
    }));
  }
  trackFeatureUpsellHover() {
    // To prevent collecting events on accidental hovers, only
    // fire the hover event if the user has moused over for 500ms.
    this.hoverTimeout = setTimeout(() => {
      this.dataApi.track('Hover Subscription Entry Point', upsellTrackingData({
        routerService: this.router,
        planToken: this.appointmentsFeatureInfo.getPlanTokenOfFeature(this.args.featureId),
        featureId: this.args.featureId,
        upsellType: this.upsellType,
        hasUsedFreeTrial: this.hasUsedFreeTrial
      }));
    }, UPSELL_EVENT_DELAY);
  }
  untrackFeatureUpsellHover() {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "appointmentsFeatureInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "planName", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "planGroupFetched", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "hasUsedFreeTrial", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "clickIconOrPopover", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clickIconOrPopover"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackFeatureUpsellViewed", [action], Object.getOwnPropertyDescriptor(_class.prototype, "trackFeatureUpsellViewed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackFeatureUpsellHover", [action], Object.getOwnPropertyDescriptor(_class.prototype, "trackFeatureUpsellHover"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "untrackFeatureUpsellHover", [action], Object.getOwnPropertyDescriptor(_class.prototype, "untrackFeatureUpsellHover"), _class.prototype), _class);
export { AppointmentsFeatureUpsellComponent as default };